<template>
  <v-sheet :color="$mainColor" :style="{height:height+'px'}" class="backSnow overflow-hidden">
    <canvas ref="snow" :style="{height:height+'px'}" style="opacity:0.5"></canvas>
  </v-sheet>
</template>

<script>
export default {
  props: ['height'],
  data:()=>({
    snowflakes: [],
    animationId: null,
    ctx: null,
    w: 0,
    h: 0,
    SNOW_COUNT: 100,
    speed: 0.3
  }),
  mounted() {
    this.initCanvas();
    this.initSnow();
    this.animate();
    window.addEventListener('resize', this.resize);
  },
  watch:{
    height(){
      this.resize();
    }
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationId);
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.snow;
      this.ctx = canvas.getContext('2d');
      this.resize();
    },

    resize() {
      const canvas = this.$refs.snow;
      this.w = canvas.width = window.innerWidth;
      this.h = canvas.height = this.height;
    },

    initSnow() {
      this.snowflakes = [];

      for (let i = 0; i < this.SNOW_COUNT; i++) {
        this.snowflakes.push(this.createSnowflake(true));
      }
    },

    createSnowflake(anyY = false) {
      return {
        x: Math.random() * this.w,
        y: anyY ? Math.random() * this.h : -10,
        r: Math.random() * 2 + 1,
        baseSpeed: Math.random() * 0.3 + 0.1, // базовая скорость
        wind: Math.random() * 0.6 - 0.3,
        alpha: Math.random() * 0.5 + 0.3
      };
    },

    updateSnowflake(flake) {
      const speed = flake.baseSpeed * this.speed;

      flake.y += speed;
      flake.x += flake.wind * 0.2 * this.speed;

      if (
          flake.y > this.h ||
          flake.x < -10 ||
          flake.x > this.w + 10
      ) {
        Object.assign(flake, this.createSnowflake());
      }
    },

    drawSnowflake(flake) {
      this.ctx.globalAlpha = flake.alpha;
      this.ctx.beginPath();
      this.ctx.arc(flake.x, flake.y, flake.r, 0, Math.PI * 2);
      this.ctx.fill();
    },

    animate() {
      this.ctx.clearRect(0, 0, this.w, this.h);
      this.ctx.fillStyle = '#fff';

      for (let i = 0; i < this.snowflakes.length; i++) {
        const flake = this.snowflakes[i];
        this.updateSnowflake(flake);
        this.drawSnowflake(flake);
      }

      this.animationId = requestAnimationFrame(this.animate);
    }
  }
};
</script>

<style lang="scss" scoped>
.backSnow{
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  z-index: -1;
}
</style>